import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

export default class extends Controller {
  static targets = ["actionBar"]

  declare readonly actionBarTarget: HTMLElement

  connect() {
    this.actionBarTarget.classList.remove("is-completely-hidden")
  }

  showAll(event: Event) {
    event.preventDefault()

    const url = new URL(window.location.href)
    url.searchParams.set("show_all_orders", "true")

    Turbo.visit(url.toString(), { action: "replace" })
  }
}